/**
 * TabBar — die klassische bottom-border Tab-Bar (`border-b-2 border-[#0A0A0A]`).
 *
 * Nicht Pill-Style — sondern die einheitliche flat Tab-Bar, die außerhalb
 * von STX (Marketplace, Feed, Orders, Studio, Messages) verwendet wird.
 * Beim STX Valeszka-Style wird diese Bar nicht eingesetzt (dort PillChip).
 *
 * Farb-Varianten:
 *   - "neutral" (default): #0A0A0A active · #999 inactive
 *   - "stx":              stx-accent active · stx-text-muted inactive
 */
export default function TabBar({
  tabs = [],           // [{ key, label, badge?, icon?, suffix?, testId? }]
  activeKey,
  onChange,
  variant = "neutral",
  fullWidth = true,
  className = "",
  testId,
  sticky = false,
}) {
  const VARIANTS = {
    neutral: {
      wrap: "border-b border-[#E5E5E5]",
      active: "text-[#0A0A0A] border-b-2 border-[#0A0A0A]",
      inactive: "text-[#999] border-b-2 border-transparent",
    },
    stx: {
      wrap: "border-b border-stx-border",
      active: "text-stx-accent border-b-2 border-stx-accent",
      inactive: "text-stx-text-muted border-b-2 border-transparent",
    },
  };
  const v = VARIANTS[variant] || VARIANTS.neutral;
  return (
    <div
      data-testid={testId}
      role="tablist"
      className={`flex ${v.wrap} ${sticky ? "sticky top-0 bg-white z-10" : ""} ${className}`}
    >
      {tabs.map((t) => (
        <button
          key={t.key}
          role="tab"
          data-testid={t.testId || `tab-${t.key}`}
          onClick={() => onChange && onChange(t.key)}
          className={`${fullWidth ? "flex-1" : "px-4"} h-11 inline-flex items-center justify-center gap-1.5 text-sm font-medium transition-colors relative ${activeKey === t.key ? v.active : v.inactive}`}
          aria-selected={activeKey === t.key}
        >
          {t.icon}
          <span>{t.label}</span>
          {t.suffix != null && (
            <span className="text-[10px] text-[#999]">{t.suffix}</span>
          )}
          {t.badge > 0 && (
            <span className="ml-1 inline-flex w-4 h-4 bg-red-500 text-white text-[9px] font-bold rounded-full items-center justify-center">
              {t.badge}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
